import {defineStore} from 'pinia'
import {AccountNs, CommonNs, SettingNs} from "@shared/types";
import {ImageApi, SettingsApi} from "@/api";
import {useWorkspaceStore} from "@shared/stores/workspace.store";


export const useCompanyStore = defineStore("company", {
    state: () => ({
        companyInfo: {} as SettingNs.CompanyInfo,
    }),
    getters: {
        getCompanyInfo: (state) => state.companyInfo,
    },
    actions: {
        setCompanyInfo(companyInfo: SettingNs.CompanyInfo): void {
            if (!companyInfo.company) {
                companyInfo.company = {
                    permission: CommonNs.PermissionsEnums.EVERYONE,
                    inputValue: '',
                } as AccountNs.AccountProperty;
            }
            this.companyInfo = companyInfo;
        },

        async loadCompanyInfo(payload: SettingNs.CompanyInfoRequest): Promise<SettingNs.CompanyInfo> {
            return SettingsApi.getCompanyInfo(payload)
                .then((companyInfo: SettingNs.CompanyInfo) => {
                    this.setCompanyInfo(companyInfo)
                    return this.companyInfo
                })
        },

        async updateCompanyProperty(
            payload: SettingNs.UpdateCompanyInfoRequest
        ): Promise<SettingNs.CompanyInfo> {
            return SettingsApi.updateCompanyProperties(payload)
                .then((companyInfo) => {
                    this.setCompanyInfo(companyInfo)
                    return this.companyInfo
                })
        },

        async uploadCompanyCover(
            payload: FormData
        ): Promise<CommonNs.AnyResponse> {
            const wsStore = useWorkspaceStore();
            const workspaceId = wsStore.getSelectedWorkspaceId
            payload.append('workspaceId', workspaceId)
            payload.append('bucketType', CommonNs.ImageBucketEnums.COMPANY_COVER_BUCKET)
            return ImageApi.uploadImage(payload).then((response: CommonNs.AnyResponse) => response)
        },

        async uploadCompanyAvatar(
            payload: FormData
        ): Promise<CommonNs.AnyResponse | Error> {
            const wsStore = useWorkspaceStore();
            const workspaceId = wsStore.getSelectedWorkspaceId
            payload.append('workspaceId', workspaceId)
            payload.append('bucketType', CommonNs.ImageBucketEnums.COMPANY_IMAGE_BUCKET)
            return ImageApi.uploadImage(payload).then((response: CommonNs.AnyResponse) => response)
        },

        async removeCompanyAvatar(
            payload: string
        ): Promise<CommonNs.AnyResponse> {
            const wsStore = useWorkspaceStore();
            const workspaceId = wsStore.getSelectedWorkspaceId
            return ImageApi.removeImage(workspaceId, CommonNs.ImageBucketEnums.COMPANY_IMAGE_BUCKET, payload)
                .then((response: CommonNs.AnyResponse) => response)
        },

        async removeCompanyCover(
            payload: string
        ): Promise<CommonNs.AnyResponse> {
            const wsStore = useWorkspaceStore();
            const workspaceId = wsStore.getSelectedWorkspaceId
            return ImageApi.removeImage(workspaceId, CommonNs.ImageBucketEnums.COMPANY_COVER_BUCKET, payload)
                .then((response: CommonNs.AnyResponse) => response)
        }

    }
})
